export const imageModules = import.meta.glob('/src/assets/images/**/*.svg')
